import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { NotFound } from "@/app/not-found";
import Container from "@/components/Container";
import Columns from "@/components/Columns";
import Column from "@/components/Column";
import Text from "@/components/Text";
import Button from "@/components/Button";

// Erros de render capturados pelo react-router NAO chegam ao Sentry sozinhos
// (o errorElement engole antes do window.onerror). Reportamos aqui e mostramos
// uma tela amigavel — nunca a mensagem tecnica para o cliente.
export function ErrorBoundary() {
  const error = useRouteError();
  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (!isNotFound) {
      console.error(error);
      Sentry.captureException(error, {
        tags: { "error.boundary": "router" },
      });
    }
  }, [error, isNotFound]);

  if (isNotFound) {
    return <NotFound />;
  }

  return (
    <Container>
      <Columns justifyContent="center" alignItems="center" className="h-screen">
        <Column size={[12, 6]} className="text-center">
          <div className="w-full py-2 text-center">
            <img src="/tim_logo.svg" alt="Logo da TIM" className="inline-block" />
          </div>
          <div className="pb-5 pt-3">
            <Text as="h2" kind="blue" className="font-bold leading-none" size="xl">
              Algo deu errado
            </Text>
            <Text as="p" kind="gray" className="pt-px">
              Não foi possível continuar por aqui. Recomece sua compra e, se o
              problema persistir, fale com a gente.
            </Text>
          </div>
          {/* Reload completo: descarta o estado em memoria que causou o erro */}
          <Button type="button" onClick={() => window.location.assign("/")}>
            Voltar para a página inicial
          </Button>
        </Column>
      </Columns>
    </Container>
  );
}
